import React from 'react';
import { motion } from 'framer-motion';

interface EventCardSectionProps {
  showContent: boolean;
  onDisplayComplete?: () => void; 
}

const EventCardSection: React.FC<EventCardSectionProps> = ({ showContent, onDisplayComplete }) => {
  if (!showContent) return null;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
      className="relative w-full max-w-[430px] mx-auto"
      onAnimationComplete={onDisplayComplete}
    >
      <div className="relative w-full">
        <img
          src="/images/opening-card.png"
          alt="Afiq & Azira Wedding 2026"
          className="w-full h-auto object-cover"
          style={{ display: 'block' }}
        />
      </div>
    </motion.div>
  );
};

export default EventCardSection;

